import serverCall from "../../serverCall";

const getClockWallpaper = async (id) => {
  const response = await serverCall.get(`/images/admin/clock-wallpaper/${id}`);
  return response;
};

const createClockWallpaper = async (data) => {
  const response = await serverCall.post(`/images/admin/clock-wallpaper`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response;
};

const updateClockWallpaper = async (id, data) => {
  const response = await serverCall.post(`/images/admin/clock-wallpaper/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response;
};

const LiveClockService = {
  getClockWallpaper,
  createClockWallpaper,
  updateClockWallpaper,
};

export default LiveClockService;
